import { useEffect, useState } from "react";
import { FaBehance, FaLinkedinIn, FaGithub } from "react-icons/fa";
import { BsMedium } from "react-icons/bs"
import { MdAlternateEmail } from "react-icons/md";
import { motion } from "framer-motion";

function NavigationBar() {
  const socialIconsContainer = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 1.5,
      },
    },
  };
  const socialIcon = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 100);
    });
  }, []);
  return (
    <nav
      className={`hidden md:block z-20 w-screen backdrop-filter bg-white dark:bg-black md:backdrop-blur-md bg-opacity-0 dark:bg-opacity-0 transition-all duration-300 ease-in-out md:-mb-24 ${
        scroll ? "fixed top-0 bg-opacity-30 dark:bg-opacity-30" : ""
      }`}
    >
      <div className="max-w-6xl mx-auto px-4">
        <div
          className={`flex items-center justify-between transition-all duration-300 ease-in-out ${
            scroll ? "h-20" : "h-24"
          }`}
        >
          <div className="w-44 fill-black dark:fill-white">
            <motion.svg
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 1.5 }}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1101.41 256.28"
              className={"cursor-pointer"}
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
            >
              <g data-name="Layer 2">
                <text
                  transform="matrix(.98 0 -.19 .98 166.57 208.25)"
                  style={{
                    fontSize: "252.17px",
                    fontFamily: "Teko-Medium,Teko",
                    fontWeight: 500,
                  }}
                >
                  {"Kushantha"}
                </text>
              </g>
            </motion.svg>
          </div>

          <motion.div
            variants={socialIconsContainer}
            initial="hidden"
            animate="show"
            className="flex gap-10 dark:text-white text-2xl"
          >
            <motion.a
              variants={socialIcon}
              href="https://www.linkedin.com/in/kushantha-sajith/"
              className="hover:text-my-purple-400 ease-in-out transition-colors duration-200"
              target={"_blank"}
            >
              <FaLinkedinIn />
            </motion.a>

            <motion.a
              variants={socialIcon}
              href="https://github.com/kushantha-sajith"
              className="hover:text-my-purple-400 ease-in-out transition-colors duration-200"
              target={"_blank"}
            >
              <FaGithub />
            </motion.a>
            {/* <motion.a
              variants={socialIcon}
              href="https://www.behance.net/#"
              className="hover:text-my-purple-400 ease-in-out transition-colors duration-200"
              target={"_blank"}
            >
              <FaBehance />
            </motion.a> */}
            <motion.a
              variants={socialIcon}
              href="https://kushanthasajith.medium.com/"
              className="hover:text-my-purple-400 ease-in-out transition-colors duration-200"
              target={"_blank"}
            >
              <BsMedium />
            </motion.a>
            <motion.a
              variants={socialIcon}
              href="mailto:kushantha018@gmail.com"
              className="hover:text-my-purple-400 ease-in-out transition-colors duration-200"
              target={"_blank"}
            >
              <MdAlternateEmail />
            </motion.a>
          </motion.div>
        </div>
      </div>
    </nav>
  );
}

export default NavigationBar;
